module.exports = (parcelRequire.load("M9Kwr")).then(() => parcelRequire('gkzhx'));